// extracted by mini-css-extract-plugin
export default {"card":"JobCard_card__u8cib","fadeInUp":"JobCard_fadeInUp__HyXyI","title":"JobCard_title__RpJ-f","location":"JobCard_location__ZQXWD","snippet":"JobCard_snippet__D7yJV"};